import { api } from 'data/api/api'

import { SearchSuggestionDto } from '../types/dtos/search-suggestion'

export type GetSearchSuggestionsArgs = {
  query: string
}

export type SearchSuggestionsResp = {
  search_suggestions: Array<SearchSuggestionDto>
}

export const getSearchSuggestions = ({ query }: GetSearchSuggestionsArgs) =>
  api.get<SearchSuggestionsResp>('/search_suggestions', {
    params: { query },
  })
